import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t, i18n } = useTranslation('common');
  const year = new Date().getFullYear();
  const lang = i18n.language || 'en';

  const quickLinks = [
    { label: t('nav.products'), to: `/${lang}/products` },
    { label: t('nav.guides'), to: `/${lang}/cssbuy-spreadsheet` },
    { label: t('nav.review'), to: `/${lang}/review` },
    { label: t('nav.shipping'), to: `/${lang}/shipping` },
    { label: t('nav.qc'), to: `/${lang}/qc` },
  ];

  const resourceLinks = [
    { label: t('nav.warehouse'), to: `/${lang}/warehouse` },
    { label: t('nav.sellers'), to: `/${lang}/sellers` },
    { label: t('nav.safety'), to: `/${lang}/safety` },
    { label: t('nav.comparisons'), to: `/${lang}/comparisons` },
  ];

  const legalLinks = [
    { label: t('footer.editorial'), to: `/${lang}/editorial-policy` },
    { label: t('footer.disclaimerPage'), to: `/${lang}/disclaimer` },
    { label: t('footer.privacy'), to: `/${lang}/privacy` },
    { label: t('footer.terms'), to: `/${lang}/terms` },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to={`/${lang}`} className="inline-flex items-center gap-2 mb-4">
              <span className="font-heading text-xl font-bold text-primary-600">CSSBuy</span>
              <span className="font-heading text-xl font-semibold text-foreground-800">Spreadsheet</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              {t('footer.disclaimer')}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-lg bg-primary-600 text-white flex items-center justify-center hover:bg-primary-700 transition-colors"
              >
                <i className="ri-store-2-line text-sm" />
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-lg bg-foreground-800 text-white flex items-center justify-center hover:bg-foreground-900 transition-colors"
              >
                <i className="ri-shopping-bag-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              {t('footer.copyright').replace('{year}', String(year))}
            </p>
            <p className="text-xs text-foreground-400">
              Not affiliated with or endorsed by CSSBuy
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}